<template>
    <ValidationObserver class="popup-add-domain" ref="form" v-slot="{handleSubmit}">
        <vs-row type="flex" class="mt-4">
            <vs-col vs-w="12" v-if="popupType === 'editDomain'">
                <div class="mb-4">
                    <ValidationProvider
                        vid="name"
                        :name="$t('modals.Domain_name')"
                        rules="required|minmax:3,50|checkDomainName"
                        v-slot="{ errors }"
                    >
                        <vs-input
                            class="w-full"
                            :label="$t('modals.Domain_name')"
                            :placeholder="$t('modals.Enter_domain')"
                            v-model="domainData.name"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>

            <vs-col vs-w="12" v-if="popupType === 'addDomain'">
                <div class="field_add_domains">
                    <ValidationProvider
                        vid="domains"
                        :name="$t('modals.Domain_name')"
                        rules="required"
                        v-slot="{ errors }"
                    >

                        <div class="vs-input--label">{{ $t('modals.Enter_domain') }}</div>
                        <vs-textarea class="w-full" :placeholder="$t('modals.Enter_domain')" @input="createArrayDomains" v-model="domainData.name"/>
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>

                <div v-if="domainsList.length" class="wrapper-chips-domain">
                    <vs-chip
                        v-for="(chip, index) of domainsList"
                        v-tooltip="chip.error && `${chip.text} ${chip.name}`"
                        @click="remove(index)"
                        :key="index"
                        closable
                        transparent
                        :color="chip.error ? chip.color : 'success'"
                        :class="{'errorMessage': chip.error && errorMessage}"
                        v-if="chip.name !== ' '"
                    >{{ chip.name }}</vs-chip>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="mr-4">
                    <ValidationProvider
                        vid="team"
                        :name="$t('global.Team')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="vs-input--label">{{ $t('global.Team') }}</div>
                        <v-select
                            :options="options.team"
                            :reduce="item => item.id"
                            label="name"
                            :clearable="false"
                            :placeholder="$t('global.Team')"
                            autocomplete
                            appendToBody
                            v-model="domainData.team_id"
                            @input="changeSelect"
                            :calculate-position="withPopper"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div>
                    <ValidationProvider
                        vid="affiliate"
                        :name="$t('global.Affiliate')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="vs-input--label">{{ $t('global.Affiliate') }}</div>
                        <v-select
                            ref="select"
                            :options="options.affiliate"
                            :reduce="item => item.hash"
                            label="name"
                            :clearable="false"
                            :placeholder="$t('global.Affiliate')"
                            autocomplete
                            appendToBody
                            v-model="domainData.affiliate_hash"
                            :calculate-position="withPopper"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </div>
            </vs-col>
        </vs-row>
        <vs-row v-if="errorDomains.length">
            <vs-col vs-w="12" style="background-color: #f8f8f8; border-radius: 5px" class="mt-2 mb-2">
                <div class="flex items-center justify-between p-2">
                    <div>{{$t('validationErrors.errorAddTitle')}}</div>
                    <vs-button @click="editErrorsDomains" v-tooltip="'Редактировать'" radius color="primary" type="flat" icon-pack="feather" icon="icon-edit-2"></vs-button>
                </div>
                <vs-divider class="m-0"/>
                <div class="flex items-center p-2" v-for="(domain, index) of errorDomains" :key="index">
                    <vs-icon icon-pack="feather" icon="icon-alert-circle" color="danger"></vs-icon>
                    <div class="ml-2">{{domain}}</div>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="mt-5">
            <vs-col vs-w="12" class="text-right">
                <vs-button @click="handleSubmit(send)" color="success" type="filled">{{
                        $t('buttons.Save')
                    }}
                </vs-button>
            </vs-col>
        </vs-row>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {mapActions, mapGetters} from 'vuex'
import EventBus from '../../../store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import {vSelectPosition} from "@/utils/mixins";

export default {
    mixins: [vSelectPosition],

    data() {
        return {
            domainData: {
                name: '',
                team_id: null,
                affiliate_hash: null
            },
            domainsList: [],
            options: {
                team: [],
                affiliate: []
            },
            errorMessage: false,
            errorDomains: []
        }
    },

    props: {
        popupData: {
            type: Object,
            require: true
        },
        popupType: {
            type: String
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    computed: {
        ...mapGetters(['teams', 'users'])
    },

    methods: {
        ...mapActions(['ADD_DOMAIN', 'EDIT_DOMAIN']),

        _splitByData(data, split) {
            return data.split(split).filter(item => item).map(item => item.toLowerCase())
        },

        remove(index) {
            delete this.domainsList[index]
            this.createArrayDomains(this._splitByData(this.domainsList.map(item => item.name).join(), ',').join())
        },

        editErrorsDomains() {
            this.createArrayDomains(this.errorDomains.join(','))
            this.errorDomains = []
        },

        createArrayDomains(domain) {
            this.domainData.name = this._splitByData(domain, ' ').join()
            const list = this._splitByData(domain, ',')
            const arr = []
            list.forEach(item => {
                if (item) {
                    let obj = {name: item, error: false, text: this.$t('error.messageErrorDomain'), color: 'danger'};
                    const invalidDomain = !/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(item)
                    if (invalidDomain) {
                        obj.error = invalidDomain
                    } else if (arr.some(i => i.name === item)) {
                        obj.error = true
                        obj.text = this.$t('error.messageDuplicateDomain')
                        obj.color = 'warning'
                    }
                    arr.push(obj)
                }
            })
            this.domainsList = arr
        },

        changeSelect() {
            const team = this.teams.find(team => team.id === this.domainData.team_id)
            this.options.affiliate = team.users
            this.domainData.affiliate_hash = null
        },

        async send() {
            let domainError = true
            if (this.popupType === 'addDomain') {
                this.domainsList.map(item => {
                    if (item.error) {
                        domainError = false
                        this.errorMessage = true
                    }
                })
            }

            if (domainError) {
                this.errorMessage = false
                const nameAction = this.popupType === 'addDomain' ? 'ADD_DOMAIN' : 'EDIT_DOMAIN';
                await this.saveDomain(nameAction)
            }
        },

        async saveDomain(nameActions) {
            try {
                const data = {
                    affiliate_hash: this.domainData.affiliate_hash,
                    domains: this.domainsList.map(item => item.name),
                    team_id: this.domainData.team_id
                }

                if (this.popupType === 'editDomain') {
                    delete data.domains
                    data.name = this.domainData.name.trim()
                    data.id = this.popupData.id
                }

                const response = await this[nameActions](data).then(response => response.result)

                if (this.popupType === 'addDomain') {
                    this.errorDomains = []
                    if (response && Object.keys(response).length) {
                        this.createArrayDomains('')
                        Object.keys(response).map(errorName => {
                            if (errorName === 'wrong_domains' && response[errorName].length) {
                                response[errorName].map(domain => this.errorDomains.push(domain))
                            } else {
                                EventBus.$emit('emitPopupEvent', {type: 'close'})
                            }
                        })
                    }
                } else {
                    EventBus.$emit('emitPopupEvent', {type: 'close'})
                }
            } catch (error) {
                if (error.response && error.response.data && error.response.data.result) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))

                    Object.keys(response).map(errorName => {
                        if (errorName === 'wrong_domains') {
                            response[errorName].map(domain => {
                                const index = this.domainsList.findIndex(item => item.name === domain)
                                this.domainsList[index].error = true
                                this.domainsList[index].text = this.$t('bgErrors.uniqueDomain')
                            })
                        }
                    })
                }

                new ErrorHandler(error).send
            }
        },
    },

    async mounted() {
        try {
            this.options.team = [...this.teams]

            if (this.popupType === 'editDomain') {
                this.domainData.id = this.popupData.id
                this.domainData.name = this.popupData.name
                this.domainData.team_id = this.popupData.team_id
                this.changeSelect()
                this.domainData.affiliate_hash = this.popupData.affiliate_hash

            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    },
}
</script>

<style lang="scss">
.popup-add-domain {
    margin-top: 0 !important;

    &__select {
        input {
            font-size: 1rem !important;
            color: rgba(0, 0, 0, .4) !important;
        }
    }

    .errorMessage {
        button {
            background: red;
        }

        //border: 2px solid #ff2929;
    }

    .vs-con-textarea {
        margin-bottom: 0 !important;
    }

    .field_add_domains {
        margin-bottom: 8px;
    }

    .wrapper-chips-domain {
        margin-top: 8px;
    }
}
</style>
